/**
 * http method 정의
 */
export enum HttpMethod {
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
  PUT = 'put',
  DELETE = 'delete',
}

/**
 * HTTP Protocol
 */
export enum HttpProtocol {
  HTTP = 'http',
  HTTPS = 'https',
}
